/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserProfileApiService } from './services/user-profile-api.service';
import { UserPaymentsApiService } from './services/user-payments-api.service';
import { UserBookingsApiService } from './services/user-bookings-api.service';
import { UserBookingSharesApiService } from './services/user-booking-shares-api.service';
import { PartnerApiService } from './services/partner-api.service';
import { AdminVouchersApiService } from './services/admin-vouchers-api.service';
import { AdminUsersApiService } from './services/admin-users-api.service';
import { AdminTowerWishesApiService } from './services/admin-tower-wishes-api.service';
import { AdminTowersApiService } from './services/admin-towers-api.service';
import { AdminTowerGroupsApiService } from './services/admin-tower-groups-api.service';
import { AdminSubscriptionsApiService } from './services/admin-subscriptions-api.service';
import { AdminPinpadsApiService } from './services/admin-pinpads-api.service';
import { AdminOrganizationsApiService } from './services/admin-organizations-api.service';
import { AdminNewsApiService } from './services/admin-news-api.service';
import { AdminImagesApiService } from './services/admin-images-api.service';
import { AdminHelpApiService } from './services/admin-help-api.service';
import { AdminBookingsApiService } from './services/admin-bookings-api.service';
import { AuthenticationApiService } from './services/authentication-api.service';
import { UserVouchersApiService } from './services/user-vouchers-api.service';
import { UserTowerGroupsApiService } from './services/user-tower-groups-api.service';
import { UserStripePaymentsApiService } from './services/user-stripe-payments-api.service';
import { UserPayrexxPaymentsApiService } from './services/user-payrexx-payments-api.service';
import { UserPaypalPaymentsApiService } from './services/user-paypal-payments-api.service';
import { UserFreeHoursPaymentsApiService } from './services/user-free-hours-payments-api.service';
import { UserNewsApiService } from './services/user-news-api.service';
import { UserInvitesApiService } from './services/user-invites-api.service';
import { UserStripeCardsApiService } from './services/user-stripe-cards-api.service';
import { TowerWishesApiService } from './services/tower-wishes-api.service';
import { PayrexxPublicPaymentsApiService } from './services/payrexx-public-payments-api.service';
import { NewsPublicApiService } from './services/news-public-api.service';
import { AdminPaymentsApiService } from './services/admin-payments-api.service';
import { AdminNotificationsApiService } from './services/admin-notifications-api.service';
import { AdminInfoApiService } from './services/admin-info-api.service';
import { UserSubscriptionsApiService } from './services/user-subscriptions-api.service';
import { UserHelpApiService } from './services/user-help-api.service';
import { SwisspassApiService } from './services/swisspass-api.service';
import { VersionApiService } from './services/version-api.service';
import { ImagesApiService } from './services/images-api.service';
import { FaqApiService } from './services/faq-api.service';
import { AdminPartnerPaymentsApiService } from './services/admin-partner-payments-api.service';
import { AdminLogApiService } from './services/admin-log-api.service';
import { AdminInvoicesApiService } from './services/admin-invoices-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserProfileApiService,
    UserPaymentsApiService,
    UserBookingsApiService,
    UserBookingSharesApiService,
    PartnerApiService,
    AdminVouchersApiService,
    AdminUsersApiService,
    AdminTowerWishesApiService,
    AdminTowersApiService,
    AdminTowerGroupsApiService,
    AdminSubscriptionsApiService,
    AdminPinpadsApiService,
    AdminOrganizationsApiService,
    AdminNewsApiService,
    AdminImagesApiService,
    AdminHelpApiService,
    AdminBookingsApiService,
    AuthenticationApiService,
    UserVouchersApiService,
    UserTowerGroupsApiService,
    UserStripePaymentsApiService,
    UserPayrexxPaymentsApiService,
    UserPaypalPaymentsApiService,
    UserFreeHoursPaymentsApiService,
    UserNewsApiService,
    UserInvitesApiService,
    UserStripeCardsApiService,
    TowerWishesApiService,
    PayrexxPublicPaymentsApiService,
    NewsPublicApiService,
    AdminPaymentsApiService,
    AdminNotificationsApiService,
    AdminInfoApiService,
    UserSubscriptionsApiService,
    UserHelpApiService,
    SwisspassApiService,
    VersionApiService,
    ImagesApiService,
    FaqApiService,
    AdminPartnerPaymentsApiService,
    AdminLogApiService,
    AdminInvoicesApiService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
